module.exports = __webpack_public_path__ + "img/graveyard.d90af653.png";